module.exports = __webpack_public_path__ + "assets/img/ca8e-im.svg";